import React from 'react';

import StockFilterRange from '@/components/StockFilterRange';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarYear,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';

function YearFilter() {
  const dispatch = useTypedDispatch();
  const selectedYear =
    useTypedSelector(getSelectedFilters).selectedParams.selectedYear;

  const handleBlurYear = (year: RangeType) => {
    dispatch(setCarYear(year));
    dispatch(setPage(1));
  };

  return (
    <StockFilterRange
      label="Год выпуска"
      values={selectedYear}
      onBlur={handleBlurYear}
    />
  );
}

export default YearFilter;
